/**
 * Enmascara un API Key: primeros 5 caracteres + 34 asteriscos fijos + últimos 4.
 * Mismo patrón visual que el portal viejo (no depende del largo real de la key),
 * pero a diferencia del original no lanza excepción si la key es corta.
 */
export function maskApiKey(key: string | undefined | null): string {
  if (!key) return '';
  if (key.length <= 9) return key;
  return `${key.slice(0, 5)}${'*'.repeat(34)}${key.slice(-4)}`;
}
